import * as React from 'react'
import { sx, Typography } from '@applift/factor'
import { ClipboardRemove } from '@applift/icons'
import { GridOverlay, GridOverlayProps } from './containers/GridOverlay'

export interface GridNoRowsOverlayProps extends GridOverlayProps {
  title?: string
  description?: string
  icon?: JSX.Element
}

export const GridNoRowsOverlay = React.forwardRef<
  HTMLDivElement,
  GridNoRowsOverlayProps
>(function GridNoRowsOverlay(props, ref) {
  const {
    icon = <ClipboardRemove color="secondary" fontSize={24} sx={{ mb: 16 }} />,
    title = 'No rows found',
    description = '',
  } = props
  return (
    <GridOverlay
      ref={ref}
      {...props}
      className={sx({ flexDirection: 'column' })}
    >
      {icon}
      <Typography
        component="h5"
        variant="bodyMedium"
        align={'center'}
        sx={{ textColor: 'neutral-600' }}
      >
        {title}
      </Typography>
      <Typography
        component="p"
        align={'center'}
        variant="bodySmall"
        sx={{ textColor: 'neutral-600' }}
      >
        {description}
      </Typography>
    </GridOverlay>
  )
})
